import { VARIANTS } from '@jobcase/react_pattern_library/components/Toaster/Toaster';

import { setNotification } from '../../notification/actions';
import hubsEntity from '../../entities/hubs/entity';
import { getProfileKey } from '../../authentication/selectors';

const TYPES = {
  HUB_FEATURE_ELEMENT_COUNT_REQUEST: 'hubs/HUB_FEATURE_ELEMENT_COUNT_REQUEST',
  HUB_FEATURE_ELEMENT_COUNT_SUCCESS: 'hubs/HUB_FEATURE_ELEMENT_COUNT_SUCCESS',
  HUB_FEATURE_ELEMENT_COUNT_FAILURE: 'hubs/HUB_FEATURE_ELEMENT_COUNT_FAILURE',
};

const getHubFeatureElementCount = options => async (dispatch, getState) => {
  const profileKey = getProfileKey(getState());
  dispatch({ type: TYPES.HUB_FEATURE_ELEMENT_COUNT_REQUEST });
  try {
    const response = await hubsEntity.api.getHubFeatureElementCount({ ...options, profileKey });
    const data = response?.data;
    const hubId = options?.hubId;
    dispatch({ type: TYPES.HUB_FEATURE_ELEMENT_COUNT_SUCCESS, payload: { [hubId]: data } });
    return response;
  } catch (error) {
    dispatch({ type: TYPES.HUB_FEATURE_ELEMENT_COUNT_FAILURE, payload: error });
    if (error.errors.length) {
      dispatch(setNotification(`An error occurred while loading the hub. ${error.errors[0]}`, VARIANTS.INFO));
    } else {
      dispatch(setNotification('An error occurred while loading the hub.', VARIANTS.INFO));
    }
    throw error;
  }
};

export {
  TYPES,
  getHubFeatureElementCount,
};

export default {
  TYPES,
  getHubFeatureElementCount,
};
